import React from "react";
import parse from "html-react-parser";
import { Button } from "../../components/Button/Button";
import { Icon } from "../../components/Icon/Icon";
import { LinkText } from "../../components/LinkText/LinkText";
import { SectionText } from "../../components/SectionText/SectionText";

export const Recap = ({
  type,
  customClasses,
  labelIcon,
  label,
  url,
  title,
  description,
  details,
  labelShow,
  labelText,
  rateNumb,
  rate,
  tan,
  tanValue,
  taeg,
  taegValue,
  link,
  info,
  appointmentText,
  appointmentCity,
  appointmentAddress,
  appointmentDate,
  buttonIcon,
  buttonLabel,
  linkCustomClasses,
  buttonRecapOnClick,
  modalRecapOnClick,
  linkUrlRecap,
  linkUrlButton,
}) => {
  function renderContent(content) {
    switch (content) {
      case "money-recap":
        const article = (
          <article
            className={["recap-container", type, customClasses].join(" ")}
          >
            <aside className="red-label">
              <Icon setViewBox="yes" name={labelIcon} />
              <span>{label}</span>
            </aside>
            <header>
              <Icon setViewBox="yes" name={url} />
              <h3 className="title">{title}</h3>
              <p>{description}</p>
            </header>
            <dl>
              <dt>
                <h4 className="details">{details}</h4>
                {labelShow === "yes" ? (
                  <p className="green-label">{labelText}</p>
                ) : (
                  ""
                )}
              </dt>
              <dd>
                <span>{rateNumb}</span>
                <span className="info-value">{rate}</span>
              </dd>

              <dd>
                <span>{tan}</span>
                <span className="info-value">{tanValue}</span>
              </dd>

              <dd>
                <span>
                  {" "}
                  <strong>{taeg}</strong>{" "}
                </span>
                <span className="info-value">{taegValue}</span>
              </dd>
            </dl>

            {link === "yes" ? (
              <LinkText
                type="info-link"
                preLinkText="Vedi le "
                linkText="Informazioni Trasparenti"
                customClasses={linkCustomClasses}
                modal="yes"
                onClick={modalRecapOnClick}
              />
            ) : (
              ""
            )}

            <Button
              type="link"
              linkUrl={linkUrlButton}
              mode="primary"
              label={buttonLabel}
              color="red"
              uppercase="yes"
              withIcon="yes"
              positionIcon="right"
              iconName={buttonIcon}
              customClasses="--animated-arrow"
              onClick={buttonRecapOnClick}
            />

            {info && <p>{info}</p>}
          </article>
        );
        return article;

      case "appointment-recap":
        const div = (
          <>
            <div className="recap-container appointment-recap mBottom7x tab_text-center">
              <SectionText
                hideTitle="yes"
                textLabel={appointmentText}
                customClasses="mBottom4x "
              />

              <section className="appointments">
                <div className="appointment mBottom4x">
                  <Icon setViewBox="yes" name="calendar-ok" />
                  <div className="appointment-text">
                    <SectionText
                      titleLabel={appointmentCity}
                      textLabel={appointmentAddress}
                      customClasses="--recap "
                    />
                  </div>
                </div>

                <div className="appointment mBottom4x">
                  <Icon setViewBox="yes" name="location" />
                  <SectionText
                    titleLabel={appointmentDate}
                    hideText="yes"
                    customClasses="--recap "
                  />
                </div>
              </section>

              <Button
                type="link"
                linkUrl={linkUrlButton}
                mode="primary"
                label="conferma"
                color="red"
                uppercase="yes"
                withIcon="yes"
                positionIcon="right"
                customClasses="mBottom4x --animated-arrow"
                onClick={buttonRecapOnClick}
              />

              <SectionText
                hideTitle="yes"
                textLabel={parse(
                  `Oppure <a href=${linkUrlRecap}>Modifica appuntamento</a>`
                )}
                customClasses=" text-center --bigger-light-text mBottom2x"
              />
            </div>
          </>
        );

        return div;
      default:
        return <p>No matching content to display</p>;
    }
  }
  return renderContent(type);
};
